import { useUser } from '@hooks/useUser.ts';
import { PermissionTypesEnum } from '@mock/Permissions.ts';

/**
 * Check permissions for a specific organization + portal (client/supplier pages).
 */
export const useHasPermission = (organizationId: number, portalId: number, ...permissions: PermissionTypesEnum[]): boolean => {
  const { beUser } = useUser();
  const org = beUser?.organizations?.find(o => o.id === organizationId);
  if (!org) return false;
  const portal = org.portals?.find(p => p.id === portalId);
  if (!portal?.permissions) return false;
  return permissions.some(p => portal.permissions!.includes(p));
};

/**
 * Check permissions globally across all organizations (admin pages).
 * Uses the flat permissions list (union of all org permissions).
 */
export const useHasGlobalPermission = (...permissions: PermissionTypesEnum[]): boolean => {
  const { beUser } = useUser();
  if (!beUser?.permissions) return false;
  return permissions.some(p => beUser.permissions!.includes(p));
};
